import { render, staticRenderFns } from "./FormTagsValidation.vue?vue&type=template&id=02339dce&"
import script from "./FormTagsValidation.vue?vue&type=script&lang=js&"
export * from "./FormTagsValidation.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports